export function dispatchCustomEvent(element: EventTarget, eventName: string) {
	const event = new CustomEvent(eventName);
	element.dispatchEvent(event);
}
